export const SERVICE = 'CONTRACT_STATUS'
